module.exports = __webpack_public_path__ + "static/media/tottenham.fa3f3275.png";